import type { Week39PackagingSnapshot } from "./packaging-report-types.js";
import { isPackagingWorkOrderPending } from "./packaging-work-order.js";

// Reviewed against Mikro output plans on 2026-10-05. Never infer an order from quantity alone.
const verifiedMatches = [
  { weekStart: "2026-10-05", excelWorkOrderNo: "003357 007", mikroWorkOrderNo: "003457 007", productCode: "19060342", quantity: 50, country: "ÇİN" },
  { weekStart: "2026-10-05", excelWorkOrderNo: "003435 233", mikroWorkOrderNo: "003435 223", productCode: "19006229", quantity: 550, country: "YEMEN" },
  { weekStart: "2026-10-05", excelWorkOrderNo: "003074 094", mikroWorkOrderNo: "003402 094", productCode: "19006154", quantity: 16, country: "ÖZBEKİSTAN" },
  // 2026-10-12: Excel E240=3457, G240=12002010546; Mikro IHR-3457,
  // customer/product/50 KOLİ agree. Preserve Excel HONG KONG; Mikro address is ÇİN.
  { weekStart: "2026-10-12", excelWorkOrderNo: "003357 007", mikroWorkOrderNo: "003457 007", productCode: "19060342", quantity: 50, country: "HONG KONG" },
];

/** Preserve Excel identity for notes and plans; scope corrections to the reviewed week and pair. */
export function reviewedPackagingWorkOrderMatches(snapshot: Week39PackagingSnapshot) {
  const rows = snapshot.lines.flatMap((line) => line.rows).filter((row) => !isPackagingWorkOrderPending(row));
  return verifiedMatches.filter((match) => {
    if (snapshot.weekStart !== match.weekStart) return false;
    const source = rows.filter((row) => row.workOrderNo === match.excelWorkOrderNo && row.productCode === match.productCode);
    return source.length > 0 && source.every((row) => row.country === match.country)
      && Math.abs(source.reduce((sum, row) => sum + row.allocations.reduce((total, cell) => total + cell.quantity, 0), 0) - match.quantity) < 0.000001
      && !rows.some((row) => row.workOrderNo === match.mikroWorkOrderNo && row.productCode === match.productCode);
  });
}
